import { FC, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Box } from '@mui/material';

interface Props {
  height?: number;
  href?: string | null;
  isCollapsed?: boolean;
  /** Renders the logo as solid white, for use on dark backgrounds. */
  light?: boolean;
}

export const Logo: FC<Props> = ({ height = 20, href = '/', isCollapsed, light }) => {
  const logo = useMemo(
    () => (
      <Box
        component="img"
        src={isCollapsed ? '/images/AI.png' : '/images/FullglassAI.png'}
        alt="Fullglass AI logo"
        sx={{
          height: height,
          maxWidth: '100%',
          objectFit: 'contain',
          ...(light && { filter: 'brightness(0) invert(1)' }),
        }}
      />
    ),
    [height, isCollapsed, light]
  );

  return href ? (
    <Link to={href} style={{ display: 'flex' }}>
      {logo}
    </Link>
  ) : (
    logo
  );
};
